import { useMutation } from '@apollo/react-hooks';
import { ProvidingInsuranceType, TrackingEventEnum, TrackingEventsPublicType } from '@trnsact/trnsact-shared-types';
import { MUTATION_PROCESS_INSURANCE_QUOTE_ON_OCA_SUBMISSION } from '../api/insuranceQuote/processInsuranceQuoteOnOcaSubmission';
import { useTrackingEvents } from './useTrackingEvents';
import { newRelicNoticeError } from '../tracking/newrelic';

export const useInsuranceQuote = () => {

  const [processInsuranceQuoteOnOcaSubmission, { loading: isInsuranceQuoteLoading }] = useMutation(
    MUTATION_PROCESS_INSURANCE_QUOTE_ON_OCA_SUBMISSION
  );

  const { createTrackingEvent, isTrackingEventLoading } = useTrackingEvents();

  const handleInsuranceQuoteOnOcaSubmission = async ({
    providingInsurance,
    creditApplicationId,
    accountId,
  }: {
    providingInsurance: string;
    creditApplicationId: string;
    accountId: string;
  }): Promise<{ redirected: boolean }> => {

    if (providingInsurance !== ProvidingInsuranceType.ReceiveQuote) {
      return { redirected: false };
    }

    try {
      await createTrackingEvent({
        variables: {
          input: {
            eventType: TrackingEventsPublicType.InsuranceExpress,
            event: TrackingEventEnum.OcaSubmissionQuoteRequested,
            eventData: { creditApplicationId },
            accountId,
          }
        }
      });

      const result = await processInsuranceQuoteOnOcaSubmission({ variables: { creditApplicationId, accountId } });
      const redirectUrl = result?.data?.insuranceQuote?.processInsuranceQuoteOnOcaSubmission?.redirectUrl;
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return { redirected: true };
      }
      return { redirected: false };
    } catch (error) {
      console.error('Error processing insurance quote on OCA submission:', error);
      newRelicNoticeError(error as Error, { action: 'insuranceQuoteOnSubmission', creditApplicationId });
      return { redirected: false };
    }
  };

  return {
    handleInsuranceQuoteOnOcaSubmission,
    isInsuranceQuoteProcessingLoading: isInsuranceQuoteLoading || isTrackingEventLoading,
  };
};
